module.exports = __webpack_public_path__ + "img/social-icon-facebook.3000ebd7.svg";